import { useCallback, useMemo, useSyncExternalStore } from 'react';

/** The shell switches to drawers and sheets below 1024 px (CLAUDE.md §5.1). */
export const COMPACT_QUERY = '(max-width: 1023.98px)';

export function useMediaQuery(query: string): boolean {
  // One query list per query, and a stable subscription, so renders don't re-subscribe.
  const list = useMemo(() => window.matchMedia(query), [query]);
  const subscribe = useCallback(
    (notify: () => void) => {
      list.addEventListener('change', notify);
      return () => {
        list.removeEventListener('change', notify);
      };
    },
    [list],
  );
  return useSyncExternalStore(
    subscribe,
    () => list.matches,
    () => false,
  );
}
